import { MBAppBar } from '@mercedes-benz/mbui-comps';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AppConfig } from '../../app/AppConfig';
import { StorageKey } from '../auth/DataService';
import { PopUpTask } from '../components/display/PopUpTask';
import { ServiceNowButton } from './ServiceNowButton';
import { ThemeSwitchToggle } from './ThemeSwitchToggle';

// import { MBProfileMenuItem } from "./MBMenu.ts";
import LogoutIcon from '@mui/icons-material/Logout';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataService } from '../auth/DataService';

const PageNavBar = ({ onMenuBtnClick }) => {
  // const { activeThemeID, setActiveThemeID } = useMBUITheme();
  const [isTaskPopupOpen, setTaskPopupOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();

  let value = localStorage.getItem(StorageKey.userInfo_app_id);
  let app_id = 'Applikations-ID: ' + value;

  value = localStorage.getItem(StorageKey.userInfo_sub);
  let sub = 'EMEA-ID: ' + value;

  value = localStorage.getItem(StorageKey.userInfo_name);
  let name = 'Name: ' + value;

  value = localStorage.getItem(StorageKey.userInfo_email);
  let email = 'E-Mail: ' + value;

  var ett_group = '';
  value = localStorage.getItem(StorageKey.userInfo_ett_group);
  if (value) {
    ett_group = 'Rollen: ' + value.split(',');
  } else {
    ett_group = 'Rollen: ' + value;
  }

  const onClickLogout = async () => {
    handleCloseUserMenu();
    await DataService.logout();
  };

  const onClickUserPreferences = () => {
    handleCloseUserMenu();
    navigate('/settings');
  };

  const settings = [app_id, sub, name, email, ett_group];

  const handleTaskPopupClose = () => {
    setTaskPopupOpen(false);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <MBAppBar
          enableColorOnDark
          position='fixed'
          logoShowUpBreakpoint='md'
          rightContent={
            <Box sx={{ justifyContent: 'end', display: 'flex' }}>
              {/* <Button
                variant="text"
                disableElevation
                startIcon={<AddIcon sx={{ fontSize: "large" }} />}
                style={{ display: "flex", alignItems: "center" }}
                onClick={handleCreateTask}
              >
                <span className="button-text">Create Task</span>
              </Button> */}
              <ThemeSwitchToggle showCaption={true} />
              <ServiceNowButton />
              <Tooltip title='Open settings'>
                <IconButton
                  onClick={handleOpenUserMenu}
                  sx={{ paddingLeft: 1 }}
                >
                  <Avatar
                    alt={localStorage.getItem(StorageKey.userInfo_name)}
                    src='/static/images/avatar/2.jpg'
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id='menu-appbar'
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography variant='body2' textAlign='center'>
                      {setting}
                    </Typography>
                  </MenuItem>
                ))}
                <MenuItem onClick={onClickUserPreferences}>
                  <ListItemIcon>
                    <TuneOutlinedIcon />
                  </ListItemIcon>
                  <Typography variant='body2'>User Preferences</Typography>
                </MenuItem>
                <MenuItem onClick={onClickLogout}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <Typography variant='body2'>Log out</Typography>
                </MenuItem>
              </Menu>
            </Box>
          }
          leftContent={
            <Stack
              direction={'row'}
              justifyContent={'flex-start'}
              alignItems={'center'}
            >
              <IconButton
                size='large'
                aria-label='account of current user'
                aria-haspopup='true'
                color='inherit'
                onClick={() => {
                  onMenuBtnClick();
                }}
              >
                <MenuIcon fontSize={'large'} />
              </IconButton>
              <Typography variant='h6' noWrap component='div'>
                {AppConfig.appName}
              </Typography>
            </Stack>
          }
        />
      </Box>
      <PopUpTask isOpen={isTaskPopupOpen} onClose={handleTaskPopupClose} />
      <style>{`
        /* Hide text on small screens */
        @media (max-width: 600px) {
          .button-text {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

PageNavBar.propTypes = {
  onMenuBtnClick: PropTypes.func,
};

PageNavBar.defaultProps = {};

export { PageNavBar };
